import React, { useState } from "react";
import makeRequest from "../../../utils/makeRequest";
import * as urls from "../../../utils/URLConst";
import toastNotify from "../../../utils/ToastNotify";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { handleLoader } from "../../../redux/reducers/layout";

const RenewalConfirmationModal = ({
  Title,
  Message,
  setRenewalConfirmationModal,
  renewalConfirmationModal,
  fetchClientVenderDetail,
  currentEndDate,
  tranCodeData,
}) => {
  const dispatch = useDispatch();

  const calculateNewEndDate = (currentEndDate) => {
    if (!currentEndDate) return ""; // Return empty string if currentEndDate is not provided
    const currentDate = new Date(currentEndDate);
    currentDate.setFullYear(currentDate.getFullYear() + 1);
    return currentDate.toISOString().split("T")[0];
  };

  async function handleUpdateClientVender() {
    try {
      dispatch(handleLoader(true));
      const config = {};
      const payload = {
        COMPANY_CD: tranCodeData?.COMPANY_CD,
        PRODUCT_CD: tranCodeData?.PRODUCT_CD,
        PRODUCT_QTY: tranCodeData?.PRODUCT_QTY,
        PRODUCT_PRICE: tranCodeData?.PRODUCT_PRICE,
        START_DT: tranCodeData?.START_DT,
        REM_MOBILE: tranCodeData?.REM_MOBILE,
        REM_EMAIL: tranCodeData?.REM_EMAIL,
        REM_DAYS: tranCodeData?.REM_DAYS,
        END_DT: calculateNewEndDate(currentEndDate),
        VENDOR_TRAN_CD: tranCodeData?.TRAN_CD,
      };
      const result = await makeRequest(
        "POST",
        urls.updateClientVender,
        payload,
        config
      );

      if (result.STATUS === "0") {
        toastNotify(result.MESSAGE, "success");
        setRenewalConfirmationModal(false);
        fetchClientVenderDetail();
      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Handle error
    } finally {
      dispatch(handleLoader(false));
    }
  }

  return (
    <div>
      <Modal
        backdrop="static"
        keyboard={false}
        size="sm"
        show={renewalConfirmationModal}
        onClick={() => setRenewalConfirmationModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>{Title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <h6>{Message}</h6>
          </div>
        </Modal.Body>
        <Modal.Footer className=" pb-2">
          <Button
            type="submit"
            variant="primary"
            className="btn-sm"
            onClick={() => handleUpdateClientVender()}
          >
          Renewal
          </Button>
          <Button
            type="button"
            variant="secondary"
            className="btn-sm"
            onClick={() => setRenewalConfirmationModal(false)}
            data-dismiss="modal"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default RenewalConfirmationModal;
